import { useState } from 'react'

export const useDrawerData = () => {
  const [drawerVisible, setDrawerVisible] = useState(false)

  const [drawerAllocatedTeamVisible, setDrawerAllocatedTeamVisible] =
    useState(false)

  const [drawerOriginalDataId, setDrawerDrawerOriginalDataId] = useState<
    undefined | any
  >(undefined)

  return {
    drawerVisible,
    setDrawerVisible,
    drawerAllocatedTeamVisible,
    setDrawerAllocatedTeamVisible,
    drawerOriginalDataId,
    setDrawerDrawerOriginalDataId
  }
}
